import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
  SharedModule,
  DaterangepickerModule,
  AutocompleteModule,
  ComboModule,
  InputModule,
} from 'beyond-util';

import { DnevniPlanEmitovanjaComponent } from './dnevni-plan-emitovanja.component';
import { ReportHeaderModule } from '../../../components/report-header/report-header.module';

@NgModule({
  declarations: [DnevniPlanEmitovanjaComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    ReportHeaderModule,
    DaterangepickerModule,
    AutocompleteModule,
    ComboModule,
    InputModule,
    SharedModule,
    NgxSpinnerModule,
  ],
  exports: [DnevniPlanEmitovanjaComponent],
  entryComponents: [DnevniPlanEmitovanjaComponent],
})
export class DnevniPlanEmitovanjaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/dnevni-plan-emitovanja/dnevni-plan-emitovanja.module.ts